import { Pipe, PipeTransform } from '@angular/core';
import { StoreIdentifier } from '../models/store-identifier.model';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform(items: StoreIdentifier[], filterText: string): any[] {
    if (!items) {
      return [];
    }
    if (!filterText) {
      return items;
    }

    return items.filter((item) => {
      return item.Location_CorporateLocationNumber.includes(filterText);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/filter.pipe.ts